import { ReactComponent as ChevronDown } from "./chevron-down.svg";
import { ReactComponent as CaretUp } from "./caret-up.svg";
import { ReactComponent as Spinner } from "./spinner.svg";
import { ReactComponent as LeftArrow } from "./left-arrow.svg";
import { ReactComponent as Calendar } from "./calendar.svg";
import { ReactComponent as CalendarScheduled } from "./calendar-scheduled.svg";
import { ReactComponent as AvatarRound } from "./avatar-round.svg";
import { ReactComponent as Bus } from "./bus.svg";
import { ReactComponent as Train } from "./train.svg";
import { ReactComponent as ParkingLot } from "./parking-lot.svg";
import { ReactComponent as Airplane } from "./airplane.svg";
import { ReactComponent as Prescription } from "./prescription.svg";
import { ReactComponent as DrReferral } from "./dr-referal.svg";
import { ReactComponent as LabTest } from "./test-tube.svg";
import { ReactComponent as Stethoscope } from "./stethoscope.svg";
import { ReactComponent as Syringe } from "./syringe.svg";
import { ReactComponent as EKG } from "./ekg.svg";
import { ReactComponent as XRay } from "./x-ray.svg";
import { ReactComponent as Clipboard } from "./clipboard.svg";

import chevronDown from "./chevron-down.svg";
import check from "./check.svg";
import logo from "./logo.svg";
import upDownCaret from "./up-down-caret.svg";
import infoRoundFilled from "./info-round-filled.svg";
import chevronLeft from "./chevron-left.svg";
import close from "./close.svg";
import facebook from "./facebook.svg";
import instagram from "./instagram.svg";
import linkedin from "./linkedin.svg";
import twitter from "./twitter.svg";
import megaphone from "./megaphone.svg";
import locationMarker from "./location-marker.svg";
import locationMarkerRoundFilled from "./location-marker-round-filled.svg";
import shield from "./shield.svg";
import calendarScheduled from "./calendar-scheduled-white.svg";
import avatarRound from "./avatar-round-white.svg";
import envelope from "./envelope.svg";
import telephone from "./telephone.svg";
import barcode from "./barcode.svg";
import successCheck from "./success-check.svg";
import mapMarker from "./map-marker.svg";
import flagUK from "./flag-uk.svg";
import flagCZ from "./flag-cz.svg";
import questionRound from "./question-round.svg";
import logoRound from "./logo-round.svg";

const SVGs = {
  logo,
  chevronDown,
  check,
  upDownCaret,
  infoRoundFilled,
  ChevronDown,
  chevronLeft,
  close,
  facebook,
  instagram,
  linkedin,
  twitter,
  Spinner,
  LeftArrow,
  megaphone,
  locationMarker,
  locationMarkerRoundFilled,
  shield,
  avatarRound,
  envelope,
  telephone,
  barcode,
  successCheck,
  Calendar,
  calendarScheduled,
  AvatarRound,
  CalendarScheduled,
  Bus,
  Train,
  ParkingLot,
  Airplane,
  Prescription,
  DrReferral,
  LabTest,
  Stethoscope,
  Syringe,
  EKG,
  XRay,
  mapMarker,
  flagUK,
  flagCZ,
  questionRound,
  Clipboard,
  logoRound,
  CaretUp,
} as const;

export default SVGs;
